var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage-list"},[_c('list',{attrs:{"fs":_vm.fs,"addLink":"/admin/homepages/new","apiList":"homepages?sort=rank","apiRemove":"homepages","editLink":"/admin/homepages","title":"Homepage List"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }